import { render, staticRenderFns } from "./CarPreCalcInfo.vue?vue&type=template&id=959250bc&scoped=true&"
import script from "./CarPreCalcInfo.vue?vue&type=script&lang=ts&"
export * from "./CarPreCalcInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CarPreCalcInfo.vue?vue&type=style&index=0&id=959250bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959250bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VExpandTransition,VIcon,VRow,VSimpleTable,VTooltip})
